/* Source: /home/sidsolaiyappan/skooch_ai/shared/offline_banner.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { useStoreSlice, getStoreIsOnline, subscribeStoreIsOnline } from "./store.js";
function OfflineBanner(props) {
  let _online = useStoreSlice(getStoreIsOnline, subscribeStoreIsOnline);
  if (_online) {
    return null;
  }
  return __jacJsx("div", {"className": "offline-banner", "role": "status", "aria-live": "polite"}, [__jacJsx("span", {"className": "offline-banner-dot", "aria-hidden": "true"}, []), __jacJsx("span", {"className": "offline-banner-text"}, ["Offline — showing your last synced plan. Changes sync when you reconnect."])]);
}
export {OfflineBanner};
if (typeof globalThis !== "undefined") { if (!globalThis.__jacEndpointEffects__) globalThis.__jacEndpointEffects__ = {}; Object.assign(globalThis.__jacEndpointEffects__, {"func:OfflineBanner": {"is_writer": false, "touches": ["*"]}}); };
//# sourceMappingURL=offline_banner.js.map
